'use strict';

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var debug = require('debug');

var pb = require('it-protocol-buffers');

var lp = require('it-length-prefixed');

var pipe = require('it-pipe');

var _require2 = require('streaming-iterables'),
    collect = _require2.collect,
    take = _require2.take,
    consume = _require2.consume;

var PeerInfo = require('peer-info');

var PeerId = require('peer-id');

var multiaddr = require('multiaddr');

var _require3 = require('it-buffer'),
    toBuffer = _require3.toBuffer;

var Message = require('./message');

var log = debug('libp2p:identify');
log.error = debug('libp2p:identify:error');

var _require4 = require('./consts'),
    MULTICODEC_IDENTIFY = _require4.MULTICODEC_IDENTIFY,
    MULTICODEC_IDENTIFY_PUSH = _require4.MULTICODEC_IDENTIFY_PUSH,
    AGENT_VERSION = _require4.AGENT_VERSION,
    PROTOCOL_VERSION = _require4.PROTOCOL_VERSION;

var errCode = require('err-code');

var _require5 = require('../errors'),
    codes = _require5.codes;

var IdentifyService = /*#__PURE__*/function () {
  _createClass(IdentifyService, null, [{
    key: "updatePeerAddresses",

    /**
     * Replaces the multiaddrs on the given `peerInfo`,
     * with the provided `multiaddrs`
     * @param {PeerInfo} peerInfo
     * @param {Array<Multiaddr>|Array<Buffer>} multiaddrs
     */
    value: function updatePeerAddresses(peerInfo, multiaddrs) {
      if (multiaddrs && multiaddrs.length > 0) {
        peerInfo.multiaddrs.clear();
        multiaddrs.forEach(function (ma) {
          try {
            peerInfo.multiaddrs.add(ma);
          } catch (err) {
            log.error('could not add multiaddr', err);
          }
        });
      }
    }
    /**
     * Replaces the protocols on the given `peerInfo`,
     * with the provided `protocols`
     * @static
     * @param {PeerInfo} peerInfo
     * @param {Array<string>} protocols
     */

  }, {
    key: "updatePeerProtocols",
    value: function updatePeerProtocols(peerInfo, protocols) {
      if (protocols && protocols.length > 0) {
        peerInfo.protocols.clear();
        protocols.forEach(function (proto) {
          return peerInfo.protocols.add(proto);
        });
      }
    }
    /**
     * Takes the `addr` and converts it to a Multiaddr if possible
     * @param {Buffer|String} addr
     * @returns {Multiaddr|null}
     */

  }, {
    key: "getCleanMultiaddr",
    value: function getCleanMultiaddr(addr) {
      if (addr && addr.length > 0) {
        try {
          return multiaddr(addr);
        } catch (_) {
          return null;
        }
      }

      return null;
    }
    /**
     * @constructor
     * @param {object} options
     * @param {Registrar} options.registrar
     * @param {Map<string, handler>} options.protocols A reference to the protocols we support
     * @param {PeerInfo} options.peerInfo The peer running the identify service
     */

  }]);

  function IdentifyService(options) {
    _classCallCheck(this, IdentifyService);

    /**
     * @property {Registrar}
     */
    this.registrar = options.registrar;
    /**
     * @property {PeerInfo}
     */

    this.peerInfo = options.peerInfo;
    this._protocols = options.protocols;
    this.handleMessage = this.handleMessage.bind(this);
  }
  /**
   * Send an Identify Push update to the list of connections
   * @param {Array<Connection>} connections
   * @returns {Promise<void>}
   */


  _createClass(IdentifyService, [{
    key: "push",
    value: function push(connections) {
      var _this = this;

      var pushes = connections.map( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection) {
          var _yield$connection$new, stream;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return connection.newStream(MULTICODEC_IDENTIFY_PUSH);

                case 3:
                  _yield$connection$new = _context.sent;
                  stream = _yield$connection$new.stream;
                  _context.next = 7;
                  return pipe([{
                    listenAddrs: _this.peerInfo.multiaddrs.toArray().map(function (ma) {
                      return ma.buffer;
                    }),
                    protocols: Array.from(_this._protocols.keys())
                  }], pb.encode(Message), stream, consume);

                case 7:
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](0);
                  // Just log errors
                  log.error('could not push identify update to peer', _context.t0);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 9]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return Promise.all(pushes);
    }
    /**
     * Calls `push` for all peers in the `peerStore` that are connected
     * @param {PeerStore} peerStore
     */

  }, {
    key: "pushToPeerStore",
    value: function pushToPeerStore(peerStore) {
      var connections = [];
      var connection;

      var _iterator = _createForOfIteratorHelper(peerStore.peers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peer = _step.value;

          if (peer.protocols.has(MULTICODEC_IDENTIFY_PUSH) && (connection = this.registrar.getConnection(peer))) {
            connections.push(connection);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.push(connections);
    }
    /**
     * Requests the `Identify` message from peer associated with the given `connection`.
     * If the identified peer does not match the `PeerId` associated with the connection,
     * an error will be thrown.
     *
     * @async
     * @param {Connection} connection
     * @returns {Promise<void>}
     */

  }, {
    key: "identify",
    value: function () {
      var _identify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connection) {
        var _yield$connection$new2, stream, _yield$pipe, _yield$pipe2, data, message, _message, publicKey, listenAddrs, protocols, observedAddr, id, peerInfo;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return connection.newStream(MULTICODEC_IDENTIFY);

              case 2:
                _yield$connection$new2 = _context2.sent;
                stream = _yield$connection$new2.stream;
                _context2.next = 6;
                return pipe([], stream, lp.decode(), take(1), toBuffer, collect);

              case 6:
                _yield$pipe = _context2.sent;
                _yield$pipe2 = _slicedToArray(_yield$pipe, 1);
                data = _yield$pipe2[0];

                if (data) {
                  _context2.next = 11;
                  break;
                }

                throw errCode(new Error('No data could be retrieved'), codes.ERR_CONNECTION_ENDED);

              case 11:
                _context2.prev = 11;
                message = Message.decode(data);
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](11);
                throw errCode(_context2.t0, codes.ERR_INVALID_MESSAGE);

              case 18:
                _message = message, publicKey = _message.publicKey, listenAddrs = _message.listenAddrs, protocols = _message.protocols, observedAddr = _message.observedAddr;
                _context2.next = 21;
                return PeerId.createFromPubKey(publicKey);

              case 21:
                id = _context2.sent;
                peerInfo = new PeerInfo(id);

                if (!(connection.remotePeer.toB58String() !== id.toB58String())) {
                  _context2.next = 25;
                  break;
                }

                throw errCode(new Error('identified peer does not match the expected peer'), codes.ERR_INVALID_PEER);

              case 25:
                // Get the observedAddr if there is one
                observedAddr = IdentifyService.getCleanMultiaddr(observedAddr); // Copy the listenAddrs and protocols

                IdentifyService.updatePeerAddresses(peerInfo, listenAddrs);
                IdentifyService.updatePeerProtocols(peerInfo, protocols);
                this.registrar.peerStore.replace(peerInfo); // TODO: Track our observed address so that we can score it

                log('received observed address of %s', observedAddr);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 15]]);
      }));

      function identify(_x2) {
        return _identify.apply(this, arguments);
      }

      return identify;
    }()
    /**
     * A handler to register with Libp2p to process identify messages.
     *
     * @param {object} options
     * @param {String} options.protocol
     * @param {*} options.stream
     * @param {Connection} options.connection
     * @returns {Promise<void>}
     */

  }, {
    key: "handleMessage",
    value: function handleMessage(_ref2) {
      var connection = _ref2.connection,
          stream = _ref2.stream,
          protocol = _ref2.protocol;

      switch (protocol) {
        case MULTICODEC_IDENTIFY:
          return this._handleIdentify({
            connection: connection,
            stream: stream
          });

        case MULTICODEC_IDENTIFY_PUSH:
          return this._handlePush({
            connection: connection,
            stream: stream
          });

        default:
          log.error('cannot handle unknown protocol %s', protocol);
      }
    }
    /**
     * Sends the `Identify` response to the requesting peer over the
     * given `connection`
     * @private
     * @param {object} options
     * @param {*} options.stream
     * @param {Connection} options.connection
     */

  }, {
    key: "_handleIdentify",
    value: function _handleIdentify(_ref3) {
      var connection = _ref3.connection,
          stream = _ref3.stream;
      var publicKey = Buffer.alloc(0);

      if (this.peerInfo.id.pubKey) {
        publicKey = this.peerInfo.id.pubKey.bytes;
      }

      var message = Message.encode({
        protocolVersion: PROTOCOL_VERSION,
        agentVersion: AGENT_VERSION,
        publicKey: publicKey,
        listenAddrs: this.peerInfo.multiaddrs.toArray().map(function (ma) {
          return ma.buffer;
        }),
        observedAddr: connection.remoteAddr.buffer,
        protocols: Array.from(this._protocols.keys())
      });
      pipe([message], lp.encode(), stream, consume);
    }
    /**
     * Reads the Identify Push message from the given `connection`
     * @private
     * @param {object} options
     * @param {*} options.stream
     * @param {Connection} options.connection
     */

  }, {
    key: "_handlePush",
    value: function () {
      var _handlePush2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var connection, stream, _yield$pipe3, _yield$pipe4, data, message, peerInfo;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                connection = _ref4.connection, stream = _ref4.stream;
                _context3.next = 3;
                return pipe([], stream, lp.decode(), take(1), toBuffer, collect);

              case 3:
                _yield$pipe3 = _context3.sent;
                _yield$pipe4 = _slicedToArray(_yield$pipe3, 1);
                data = _yield$pipe4[0];
                _context3.prev = 6;
                message = Message.decode(data);
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](6);
                return _context3.abrupt("return", log.error('received invalid message', _context3.t0));

              case 13:
                // Update the listen addresses
                peerInfo = new PeerInfo(connection.remotePeer);
                _context3.prev = 14;
                IdentifyService.updatePeerAddresses(peerInfo, message.listenAddrs);
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](14);
                return _context3.abrupt("return", log.error('received invalid listen addrs', _context3.t1));

              case 21:
                // Update the protocols
                IdentifyService.updatePeerProtocols(peerInfo, message.protocols); // Update the peer in the PeerStore

                this.registrar.peerStore.replace(peerInfo);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 10], [14, 18]]);
      }));

      function _handlePush(_x3) {
        return _handlePush2.apply(this, arguments);
      }

      return _handlePush;
    }()
  }]);

  return IdentifyService;
}();

module.exports.IdentifyService = IdentifyService;
/**
 * The protocols the IdentifyService supports
 * @property multicodecs
 */

module.exports.multicodecs = {
  IDENTIFY: MULTICODEC_IDENTIFY,
  IDENTIFY_PUSH: MULTICODEC_IDENTIFY_PUSH
};
module.exports.Message = Message;